// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modern-blog-detail-container {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #1a1a1a;
  line-height: 1.6;
}

/* Base Prose Styles */
.blog-main-content p {
  margin-bottom: 2rem;
}

.blog-main-content h2 {
  font-family: 'Playfair Display', serif;
  font-size: 2.25rem;
  font-weight: 900;
  margin: 4rem 0 1.75rem;
  color: #111;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.blog-main-content ul {
  margin-bottom: 2.5rem;
  padding-left: 0.5rem;
  list-style: none;
}

.blog-main-content li {
  position: relative;
  margin-bottom: 1.25rem;
  padding-left: 2rem;
  color: #333;
  font-size: 1.125rem;
}

.blog-main-content li::before {
  content: "→";
  position: absolute;
  left: 0;
  top: -2px;
  color: #3b82f6;
  font-weight: bold;
  font-size: 1.25rem;
}

/* Layout Elements */
.prose-container {
  max-width: 100%;
}

.share-buttons a {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.share-buttons a:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}



/* Transitions */
.group img {
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .modern-blog-detail-container {
    padding-top: 6rem;
  }
}

@media (max-width: 768px) {
  .modern-blog-detail-container h1 {
    font-size: 2.5rem !important;
  }
  
  .blog-main-content h2 {
    font-size: 1.5rem;
  }

  .modern-blog-detail-container .grid {
    gap: 3rem !important;
  }
}

/* Custom Scrollbar for better UX */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 10px;
  border: 3px solid #f1f1f1;
}

::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/BlogDetail.css"],"names":[],"mappings":"AAEA;EACE,mEAAmE;EACnE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;;;AAIA,gBAAgB;AAChB;EACE,wDAAwD;AAC1D;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,mCAAmC;AACnC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap');\n\n.modern-blog-detail-container {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  color: #1a1a1a;\n  line-height: 1.6;\n}\n\n/* Base Prose Styles */\n.blog-main-content p {\n  margin-bottom: 2rem;\n}\n\n.blog-main-content h2 {\n  font-family: 'Playfair Display', serif;\n  font-size: 2.25rem;\n  font-weight: 900;\n  margin: 4rem 0 1.75rem;\n  color: #111;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.blog-main-content ul {\n  margin-bottom: 2.5rem;\n  padding-left: 0.5rem;\n  list-style: none;\n}\n\n.blog-main-content li {\n  position: relative;\n  margin-bottom: 1.25rem;\n  padding-left: 2rem;\n  color: #333;\n  font-size: 1.125rem;\n}\n\n.blog-main-content li::before {\n  content: \"→\";\n  position: absolute;\n  left: 0;\n  top: -2px;\n  color: #3b82f6;\n  font-weight: bold;\n  font-size: 1.25rem;\n}\n\n/* Layout Elements */\n.prose-container {\n  max-width: 100%;\n}\n\n.share-buttons a {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.share-buttons a:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n\n\n/* Transitions */\n.group img {\n  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .modern-blog-detail-container {\n    padding-top: 6rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .modern-blog-detail-container h1 {\n    font-size: 2.5rem !important;\n  }\n  \n  .blog-main-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .modern-blog-detail-container .grid {\n    gap: 3rem !important;\n  }\n}\n\n/* Custom Scrollbar for better UX */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #ddd;\n  border-radius: 10px;\n  border: 3px solid #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
